//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

import { ICuralateSession } from 'app/basic-session/ICuralateSession';

export const getIsFacebookAppReview = createSelector(
  (state: ICuralateStore) => state.session,
  (session: ICuralateSession) => session.internalInfo.isFacebookAppReview,
);
